// MediaGalleryVideo
import React from 'react';
import PropTypes from 'prop-types';

const MediaGalleryVideo = ({ video, handleMediaClick }) => (
  <div id={`video-${video.id}`} className="" data-props={`Video,${video.productLineName},,,`} data-video-title={video.title} data-video-description={video.description} data-video-iframe={video.videoUrl} data-video-id={video.id}>
    <button type="button" className="gallery-modal-toggle play-video" aria-expanded={video.active} aria-controls={`${video.title.toLowerCase().replace(/[\s]+/g, '-')}-modal`} onClick={() => handleMediaClick(video)}>
      <div className="gallery-item--preview">
        <img className="lazy" data-src={(video.posterImage === null ? `https://i3.ytimg.com/vi/${video.id}/hqdefault.jpg` : video.posterImage)} alt={video.description} />
        <div className="loader-placeholder">
          <svg id="loading" className="loading" data-name="loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
            <title>Loading</title>
            <path className="loading-path" d="M250,149A100,100,0,1,0,150,250c1.68,0,3.34-.06,5-.14V212.29c-1.65.14-3.32.21-5,.21A62.5,62.5,0,1,1,212.47,149H200l30,30,30-30Z" />
          </svg>
        </div>
      </div>
      <div className="gallery-item--title">
        <span className="icon" />
        {video.title}
      </div>
    </button>
  </div>
);

MediaGalleryVideo.propTypes = {
  handleMediaClick: PropTypes.func.isRequired,
  video: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    videoUrl: PropTypes.string,
    posterImage: PropTypes.string,
    active: PropTypes.bool,
    productLineName: PropTypes.string,
  }),
};

export default MediaGalleryVideo;
